module.exports = __webpack_public_path__ + "static/media/shequ-entrance-6.c3935d36.png";